import React, { Component } from "react"
import MetaTags from "react-meta-tags"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import RemoteTable from "../../../components/Common/RemoteTable"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { getMTAgenciesList, integrationStateInit } from "../../../store/integration/actions"
import SweetAlert from "react-bootstrap-sweetalert"
import TokenSweetAlert from "./TokenSweetAlert"
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

class AgenciesMT extends Component {
  constructor(props) {
    super(props)

    this.state = {
      page: 1,
      sizePerPage: 10,
      filter_name: [],
      modalShowData: null
    }

    this.searchTimer = null
  }

  componentDidMount() {
    this.props.getMTAgenciesList(this.props.data)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
  }

  componentWillUnmount() {
    this.props.integrationStateInit()
  }

  handleTableChange = (data) => {
    this.props.getMTAgenciesList(data)
  }

  render() {

    const onClickEdit = row => {
      this.setState({modalShowData: row})
      // setEditModalData(row)
    }

    const actionsFormatter = (cell, row) => (
          <button
            type="button"
            className="btn btn-primary  btn-sm"
            onClick={e => onClickEdit(row)}
          >
            <i className="bx bx-show d-block font-size-16" />
          </button>
    )

    const getFormatter = (cell, row) => <div style={{height: 26}} onClick={() => onClickEdit(row)}>{cell}</div>

    const columns = [
      {
        dataField: "agency_name",
        text: "Agency name",
        sort: true,
        formatter: getFormatter
      },
      {
        dataField: "client_name",
        text: "Client name",
        sort: true,
        formatter: getFormatter
      },
      {
        dataField: "status",
        text: "Status",
        sort: true,
        formatter: (cell, row) => !cell ? getFormatter(cell, row) : <div className="text-center">
          <span
            className={`badge rounded-pill font-size-11 ${row.status === "active" ? "badge-soft-success" : "badge-soft-danger"}`}
            onClick={() => onClickEdit(row)}
          >{cell}</span>
        </div>
        // formatter: (cell, row) => <span
        //   className={`${row.status === "active" ? "text-success" : "text-danger"}`}>{row.status}</span>
      },
      {
        dataField: "currency",
        text: "Currency",
        sort: true,
        formatter: getFormatter
      },
      {
        dataField: "info_currency",
        text: "Info currency",
        sort: true,
        formatter: getFormatter
      },
      {
        dataField: "actions",
        text: "Actions",
        sort: false,
        formatter: actionsFormatter
      }
    ]

    return (
      <React.Fragment>
        <div className="page-content">
        <ModifiedMetaTags title="Agencies MyTarget | Mobihunter" />

          <Container fluid>
            <Breadcrumbs title="Dashboard" breadcrumbItem="Agencies MyTarget" link="/" />
            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    {this.state.modalShowData && <TokenSweetAlert
                      data={this.state.modalShowData}
                      onConfirm={() => this.setState({ modalShowData: false })}
                    />}
                    <RemoteTable
                      onTableChange={this.handleTableChange}
                      columns={columns}
                      data={this.props.data}
                      loading={this.props.loading}
                    >
                    </RemoteTable>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

AgenciesMT.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
  getMTAgenciesList: PropTypes.func.isRequired,
  integrationStateInit: PropTypes.func.isRequired,
  permissions: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  data: state.Integration.dataAgenciesMT,
  loading: state.Integration.loading_agencies_mytarget,
  permissions: state.User.permissions
})

export default connect(mapStateToProps, { getMTAgenciesList, integrationStateInit })(
  AgenciesMT
)
